/** @jsxImportSource @emotion/react */
import { Box, Button } from '@mui/material'
import { useAtom, useAtomValue } from 'jotai'
import { useNavigate, useParams } from 'react-router-dom'
import {
  logo,
  clientLogoWrapper,
  landingPageContainer,
  landingPageContent,
  startPresentationButton,
} from './RiskStoryLandingPage.style'
import { clientNameAtom } from '@app/state/clientsAtom'
import { selectedStoryAtom, selectedStoryIdAtom } from '@app/services/storiesService'
import { lazy, useMemo } from 'react'
import { generateLogoUrls } from '@app/utils/generateLogoUrls'
import { ErrorPage } from '@app/routes/ErrorPage'
import { PUBLIC_ASSETS_BASE_URL } from '@app/app-constants'
const UiMarkdown = lazy(() => import('@app/components/Atoms/UiMarkdown/UiMarkdown'))

const RiskStoryLandingPage = () => {
  const navigate = useNavigate()
  const clientName = useAtomValue(clientNameAtom)

  const { storyId } = useParams<{ storyId?: string }>()

  const [selectedStoryId, setSelectedStoryId] = useAtom(selectedStoryIdAtom)
  if (storyId && selectedStoryId !== Number(storyId)) {
    setSelectedStoryId(Number(storyId))
  }

  const story = useAtomValue(selectedStoryAtom)
  const logos = useMemo(() => generateLogoUrls(clientName), [clientName])

  const startPresentation = () => {
    if (story instanceof Error) return
    if (story?.summary) navigate('summary')
    else navigate('chapters')
  }

  if (!story) return <Box></Box>

  if (story instanceof Error) {
    if (story.message != 'Not found') return <ErrorPage />

    return (
      <Box css={landingPageContainer(null)}>
        <Box css={landingPageContent(undefined)}>
          <img src={logos.whiteFull} alt="Logo" css={logo()} />
          <h1>Not found</h1>
          This Risk Story is not found or private in which case it can only be viewed by those with
          a Resilience Explorer® login.
          <br />
          <br />
          <br />
          <Box css={clientLogoWrapper}>
            <a href="https://resilience-explorer.org" target="_blank" rel="noreferrer">
              <img src="/logos/Generated by REx.svg" alt="Logo" />
            </a>
          </Box>
        </Box>
      </Box>
    )
  }

  return (
    <Box css={landingPageContainer(story)}>
      <Box css={landingPageContent(story?.branding)}>
        <img
          src={`${PUBLIC_ASSETS_BASE_URL}/images/shared/new_RexLogoFull.svg`}
          alt="Logo"
          css={logo()}
        />
        <h1>{story?.title}</h1>
        <UiMarkdown>{story?.description ?? ''}</UiMarkdown>
        <br />
        <Button
          css={startPresentationButton(story?.branding)}
          variant="contained"
          onClick={startPresentation}
        >
          Start
        </Button>
        <br />
        <Box css={clientLogoWrapper}>
          <img src={logos.whiteFull} alt="Logo" css={logo()} />
        </Box>
      </Box>
    </Box>
  )
}
export default RiskStoryLandingPage
